<template>
  <div class="join_area">
    <h4>Хаяг холбох заавар</h4>
      <el-radio-group v-model="whichSalbar" class="join_branch_option">
        <div class="branch_cards">
          <div v-for="item in optionsWhichSalbar" :key="item.value" class="branch_card">
            <el-radio :label="item.value" class="custom-radio" @change="setNullValue()">
              <img :src="item.image" style="width: 150px; height: 150px;" alt="radio-img" class="radio-image" /> <br />
              <span class="radio-label">{{ item.label }}</span>
            </el-radio>
          </div>
        </div>
    </el-radio-group>
    <el-radio-group v-model="joinForm.branch" class="join_branch_option" @click="setNullValue()">
      <div v-if="whichSalbar === 'bohiinUrguuSalbar'" class="sub_branch_cards">
        <el-radio
          v-for="(item, index) in optionsBuhiinUrguu"
          :key="index"
          :label="item.value"
          class="custom-radio sub-branch-radio"
        >
          <span class="radio-label">{{ item.label }}</span>
        </el-radio>
      </div>
    </el-radio-group>
    <!-- <el-radio-group v-model="joinForm.branch" class="join_branch_option">
      <div v-if="whichSalbar === 'oficerSalbar'" class="sub_branch_cards">
        <el-radio
          v-for="(item, index) in optionsOficer"
          :key="index"
          :label="item.value"
          class="custom-radio sub-branch-radio"
        >
          <span class="radio-label">{{ item.label }}</span>
        </el-radio>
      </div>
    </el-radio-group> -->
    <el-radio-group v-model="joinForm.branch" class="join_branch_option">
      <div v-if="whichSalbar === 'gurawHoroololSalbar'" class="sub_branch_cards">
        <el-radio
          v-for="(item, index) in optionsGurawHoroolol"
          :key="index"
          :label="item.value"
          class="custom-radio sub-branch-radio"
        >
          <span class="radio-label">{{ item.label }}</span>
        </el-radio>
      </div>
    </el-radio-group>
    <el-row class="m-b-10 m-t-10" v-if="joinForm.branch === 'bohiinurguu'">
      <el-col>
          <b><i>Энгийн тээвэр 4-10 хоногт</i></b>
        </el-col>
    </el-row>
    <el-row class="m-b-10 m-t-10" v-if="joinForm.branch === 'buhiinUrguuExpress'">
      <el-col>
          <b><i>Экспресс тээвэр 2-3 хоногт</i></b>
        </el-col>
    </el-row>
    <el-row v-if="joinForm.branch === 'bohiinurguu' || joinForm.branch === 'buhiinUrguuExpress' || joinForm.branch === 'gurawHoroolol'">
      <el-col>
        <span class="p-t-10">Танд шаардлагатай мэдээлэл</span>
      </el-col>
      <el-col>
        <div class="join_info_area">
          <div class="join_info">
            <el-row>
              <el-col :span=12 class="m-t-12">Салбарын нэр:</el-col>
              <el-col :span=12>
                <!-- <span v-if="joinForm.branch === 'oficer'">天空8792</span> -->
                <span v-if="joinForm.branch === 'bohiinurguu'">天空0599</span>
                <!-- <span v-if="joinForm.branch === 'officerExpress'">天空快运8811</span> -->
                <span v-if="joinForm.branch === 'buhiinUrguuExpress'">天空快运8818</span>
                <!-- <span v-if="joinForm.branch === 'gurawHoroolol'">天空3819</span> -->
                <el-button @click="copyToClipboardBranch(joinForm.branch === 'bohiinurguu' ? '天空0599' : joinForm.branch === 'buhiinUrguuExpress' ? '天空快运8818' : '')"
                  type="text" :style="{ color: isCopiedBranch ? 'green' : 'black' }" :icon="isCopiedBranch ? 'el-icon-check' : 'el-icon-copy-document'" circle>
                </el-button>
              </el-col>
            </el-row>
          </div>
          <div class="join_info">
            <el-row>
              <el-col :span=12 class="m-t-12">Утасны дугаар (+86):</el-col>
              <el-col :span=12>
                <span v-if="joinForm.branch === 'oficer'">13474735577</span>
                <span v-if="joinForm.branch === 'bohiinurguu'">13474735577 </span>
                <span v-if="joinForm.branch === 'officerExpress'">13474735577</span>
                <span v-if="joinForm.branch === 'buhiinUrguuExpress'">13474735577</span>
                <span v-if="joinForm.branch === 'gurawHoroolol'">13474735577</span>
                <el-button @click="copyToClipboardPhone(joinForm.branch === 'oficer' ? '13474735577' : joinForm.branch === 'bohiinurguu' ? '13474735577 ' : joinForm.branch === 'officerExpress' ? '13474735577 ' : joinForm.branch === 'buhiinUrguuExpress' ? '13474735577 ' : joinForm.branch === 'gurawHoroolol' ? '13474735577' : '')" type="text" :style="{ color: isCopiedPhone ? 'green' : 'black' }" :icon="isCopiedPhone === true ? 'el-icon-check' : 'el-icon-copy-document'" circle>
                </el-button>
              </el-col>
            </el-row>
          </div>
          <div class="join_info">
            <el-row>
              <el-col :span=12 class="m-t-12">Муж (Өвөр монголын өөртөө засах орон):</el-col>
              <el-col :span=12>
                <span v-if="joinForm.branch === 'oficer'">内蒙古自治区</span>
                <span v-if="joinForm.branch === 'bohiinurguu'"> 内蒙古自治区 </span>
                <span v-if="joinForm.branch === 'officerExpress'">内蒙古自治区</span>
                <span v-if="joinForm.branch === 'buhiinUrguuExpress'">内蒙古自治区</span>
                <span v-if="joinForm.branch === 'gurawHoroolol'">内蒙古自治区</span>
                <el-button @click="copyToClipboardMuj(joinForm.branch === 'oficer' ? '内蒙古自治区' :joinForm.branch === 'bohiinurguu' ? '内蒙古自治区' : joinForm.branch === 'officerExpress' ? '内蒙古自治区' : joinForm.branch === 'buhiinUrguuExpress' ? '内蒙古自治区' : joinForm.branch === 'gurawHoroolol' ? '内蒙古自治区' : '' )" type="text" :style="{ color: isCopiedMuj ? 'green' : 'black' }" :icon="isCopiedMuj === true ? 'el-icon-check' : 'el-icon-copy-document'" circle>
                </el-button>
              </el-col>
            </el-row>
          </div>
          <div class="join_info">
            <el-row>
              <el-col :span=12 class="m-t-12">Лиг (Шилийн гол лиг):</el-col>
              <el-col :span=12>
                <span v-if="joinForm.branch === 'oficer'">錫林郭勒盟</span>
                <span v-if="joinForm.branch === 'bohiinurguu'">錫林郭勒盟</span>
                <span v-if="joinForm.branch === 'officerExpress'">锡林郭勒盟</span>
                <span v-if="joinForm.branch === 'buhiinUrguuExpress'">锡林郭勒盟</span>
                <span v-if="joinForm.branch === 'gurawHoroolol'">錫林郭勒盟</span>
                <el-button @click="copyToClipboardLig(joinForm.branch === 'oficer' ? '錫林郭勒盟' :  joinForm.branch === 'bohiinurguu' ? '錫林郭勒盟' : joinForm.branch === 'officerExpress' ? '锡林郭勒盟' : joinForm.branch === 'buhiinUrguuExpress' ? '锡林郭勒盟' : joinForm.branch === 'gurawHoroolol' ? '錫林郭勒盟' : '')" type="text" :style="{ color: isCopiedLig ? 'green' : 'black' }" :icon="isCopiedLig === true ? 'el-icon-check' : 'el-icon-copy-document'" circle>
                </el-button>
              </el-col>
            </el-row>
          </div>
          <div class="join_info">
            <el-row>
              <el-col :span=12 class="m-t-12">Эрэнхот хот:</el-col>
              <el-col :span=12>
                <span v-if="joinForm.branch === 'oficer'">二连浩特市</span>
                <span v-if="joinForm.branch === 'bohiinurguu'">二连浩特市</span>
                <span v-if="joinForm.branch === 'officerExpress'">二连浩特市</span>
                <span v-if="joinForm.branch === 'buhiinUrguuExpress'">二连浩特市</span>
                <span v-if="joinForm.branch === 'gurawHoroolol'">二连浩特市</span>
                <el-button @click="copyToClipboardEreen(joinForm.branch === 'oficer' ? '二连浩特市' : joinForm.branch === 'bohiinurguu' ? '二连浩特市' : joinForm.branch === 'officerExpress' ? '二连浩特市' : joinForm.branch === 'buhiinUrguuExpress' ? '二连浩特市' : joinForm.branch === 'gurawHoroolol' ? '二连浩特市' :  '')" type="text" :style="{ color: isCopiedEreen ? 'green' : 'black' }" :icon="isCopiedEreen === true ? 'el-icon-check' : 'el-icon-copy-document'" circle>
                </el-button>
              </el-col>
            </el-row>
          </div>
          <div class="join_info">
            <el-row>
              <el-col :span=12 class="m-t-12" v-if="joinForm.branch === 'oficer'">Эрэнхот ХЭЗТХАБ</el-col>
              <el-col :span=12 class="m-t-12" v-if="joinForm.branch === 'bohiinurguu'">Эрэнхот ХЭЗТХАБ:</el-col>
              <el-col :span=12 class="m-t-12" v-if="joinForm.branch === 'officerExpress'">Эрэнхот ХЭЗТХАБ:</el-col>
              <el-col :span=12 class="m-t-12" v-if="joinForm.branch === 'buhiinUrguuExpress'">Эрэнхот ХЭЗТХАБ:</el-col>
              <el-col :span=12 class="m-t-12" v-if="joinForm.branch === 'gurawHoroolol'">Эрэнхот ХЭЗТХАБ:</el-col>
              <el-col :span=12>
                <span v-if="joinForm.branch === 'oficer'">二连边境经济技术合作区</span>
                <span v-if="joinForm.branch === 'bohiinurguu'">二连边境经济技术合作区</span>
                <span v-if="joinForm.branch === 'officerExpress'">二连边境经济技术合作区</span>
                <span v-if="joinForm.branch === 'buhiinUrguuExpress'">二连边境经济技术合作区</span>
                <span v-if="joinForm.branch === 'gurawHoroolol'">二连边境经济技术合作区</span>
                <el-button @click="copyToClipboardEreenTo(joinForm.branch === 'oficer' ? '二连边境经济技术合作区' : joinForm.branch === 'bohiinurguu' ? '二连边境经济技术合作区' : joinForm.branch === 'officerExpress' ? '二连边境经济技术合作区' : joinForm.branch === 'buhiinUrguuExpress' ? '二连边境经济技术合作区' : joinForm.branch === 'gurawHoroolol' ? '二连边境经济技术合作区' :  '')" type="text" :style="{ color: isCopiedEreenTo ? 'green' : 'black' }" :icon="isCopiedEreenTo === true ? 'el-icon-check' : 'el-icon-copy-document'" circle>
                </el-button>
              </el-col>
            </el-row>
          </div>
          <div class="join_info">
            <el-row>
              <el-col :span=12 class="m-t-12">Дэлгэрэнгүй хаяг:</el-col>
              <el-col :span=12>
                <span v-if="joinForm.branch === 'oficer'">国门金街北区6号商铺爱蒙货代8792tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)</span>
                <span v-if="joinForm.branch === 'bohiinurguu'">国门金街北区6号商铺爱蒙货代0599tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)</span>
                <span v-if="joinForm.branch === 'officerExpress'">国门金街北区6号商铺爱蒙货代8811 ofitser express (өөрийн нэр утасны дугаарыг бичнэ)</span>
                <span v-if="joinForm.branch === 'buhiinUrguuExpress'">国门金街北区6号商铺爱蒙货代8818 buhiin urguu express (өөрийн нэр утасны дугаарыг бичнэ)</span>
                <span v-if="joinForm.branch === 'gurawHoroolol'">国门金街北区6号商铺爱蒙货代3819tenger 3horoolol (өөрийн нэр утасны дугаарыг нөхөж бичнэ)</span>
                <el-button @click="copyToClipboardDetail(joinForm.branch === 'oficer' ? '国门金街北区6号商铺爱蒙货代8792tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)': joinForm.branch === 'bohiinurguu' ? '国门金街北区6号商铺爱蒙货代0599tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)' : joinForm.branch === 'officerExpress' ? '国门金街北区6号商铺爱蒙货代8811 ofitser express (өөрийн нэр утасны дугаарыг бичнэ)' : joinForm.branch === 'buhiinUrguuExpress' ? '国门金街北区6号商铺爱蒙货代8818 buhiin urguu express (өөрийн нэр утасны дугаарыг бичнэ)' : joinForm.branch === 'gurawHoroolol' ? '国门金街北区6号商铺爱蒙货代3819tenger 3horoolol (өөрийн нэр утасны дугаарыг нөхөж бичнэ)' : '')" type="text" :style="{ color: isCopiedDetail ? 'green' : 'black' }" :icon="isCopiedDetail === true ? 'el-icon-check' : 'el-icon-copy-document'" circle>
                </el-button>
              </el-col>
            </el-row>
          </div>
          <el-button class="success_copy" @click="copyAllAddresses">Бүх хаяг хуулах</el-button><br/>
        </div>
      </el-col>
    </el-row>
    <div class="m-t-40" style="text-align: -webkit-center;">
      <span class="join_subtitle">Та ямар худалдааны флатформ дээр хаяг холбох гэж байгаа вэ?</span>
        <el-radio-group v-model="joinFormSite.site" class="join_branch_option m-t-50">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="item, index in optionsSite" :key="index" class="">
              <el-radio :label="item.value" class="custom-radio m-t-10">
                <img :src="item.image" style="width: 80px; height: 80px;" alt="radio-img" class="radio-image" /><br/>
                <span class="radio-label">{{ item.label }}</span>
              </el-radio>
            </el-col>
          </el-row>
        </el-radio-group>
      </div>
    <div>
      <!-- Taobao -->
      <div class="m-t-40" v-if="joinFormSite.site === 'Taobao'">
        <el-row class="join_step_image line-heith-2">
          <el-col :span="22" class="m-l-20">
            <a
              class="el-button el-button--primary w-100"
              href="https://www.facebook.com/share/r/1MjD2gJ6oa/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              Заавар видео
            </a>
          </el-col>
          <!-- <el-col :xs="22" :sm="12" :md="8" :lg="4" :xl="4">
            <span><b>Анхууруулга!!!</b></span><br>
            ❗️Анхааруулга ❗️Заавал өөрийн нэр, утасны дугаар гэсэн хэсэг дээр өөрийн нэр утасны дугаараа бичээрэй. <br>
            <el-image style="width: 200px; height: 400px"
            :src="'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com/Taobao/warning.jpg'"
            :preview-src-list="['https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com/Taobao/warning.jpg']"></el-image>
          </el-col> -->
        </el-row>
      </div>
      <!-- Pinduoduo -->
      <div class="m-t-40" v-if="joinFormSite.site === 'Pinduoduo'">
        <el-row class="join_step_image line-heith-2">
          <el-col :span="22" class="m-l-20">
            <a
              class="el-button el-button--primary w-100"
              href="https://www.facebook.com/share/r/12Ln6wCrXTN/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              Заавар видео
            </a>
          </el-col>
        </el-row>
      </div>
      <!-- Poizon -->
      <div class="m-t-40" v-if="joinFormSite.site === 'Poizon'">
        <el-row class="join_step_image line-heith-2">
          <el-col :span="22" class="m-l-20">
            Тун удахгүй
            <!-- <el-button class="w-100" type="primary">
              <a href="https://www.facebook.com/share/r/1MjD2gJ6oa/?mibextid=wwXIfr" target="_blank">Заавар видео</a>
            </el-button> -->
          </el-col>
        </el-row>
      </div>
      <!-- 1688 -->
      <div class="m-t-40" v-if="joinFormSite.site === '1688'">
        <el-row class="join_step_image">
          <el-col :span="22" class="m-l-20">
            <a
              class="el-button el-button--primary w-100"
              href="https://www.facebook.com/share/r/19LXWZUFxz/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Заавар видео
            </a>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>

</template>

<script>
import buhiinUrguu from '@/assets/images/buhiin_urguu.jpg'
// import officer from '@/assets/images/officer.jpg'
import horoolol from '@/assets/images/horoolol.png'

export default {
  name: 'JoinComponent',
  data () {
    return {
      row1: 'sex',
      isCopiedPhone: false,
      isCopiedBranch: false,
      isCopiedMuj: false,
      isCopiedLig: false,
      isCopiedEreen: false,
      isCopiedEreenTo: false,
      isCopiedDetail: false,
      whichSalbar: null,
      joinForm: {
        branch: null
      },
      joinFormSite: {
        site: 'Taobao'
      },
      calculateForm: {
        size: '',
        type: '',
        mass: 1,
        urt: null,
        urgun: null,
        undur: null,
        delivery: false,
        resource: '',
        desc: ''
      },
      optionsWhichSalbar: [{
        value: 'bohiinUrguuSalbar',
        label: 'Бөхийн өргөө салбар',
        image: buhiinUrguu
      }
      //   {
      //   value: 'oficerSalbar',
      //   label: 'Офицер салбар',
      //   image: officer
      // },
      ],
      optionsBuhiinUrguu: [
        {
          value: 'bohiinurguu',
          label: 'Энгийн - Бөхийн өргөө',
          image: buhiinUrguu
        },
        {
          value: 'buhiinUrguuExpress',
          label: 'Экспресс - Бөхийн өргөө',
          image: buhiinUrguu
        }
      ],
      // optionsOficer: [{
      //   value: 'oficer',
      //   label: 'Энгийн - Офицер',
      //   image: officer
      // },
      // {
      //   value: 'officerExpress',
      //   label: 'Экспресс - Офицер',
      //   image: officer
      // }
      // ],
      optionsGurawHoroolol: [
        {
          value: 'gurawHoroolol',
          label: 'Энгийн - 3-р хороолол',
          image: horoolol
        }
      ],
      optionsSite: [
        {
          value: 'Taobao',
          label: 'Taobao',
          image: 'https://no-more-fairytales.com/wp-content/uploads/2024/06/taobao-logo.png'
        }, {
          value: 'Pinduoduo',
          label: 'Pinduoduo',
          image: 'https://cdn6.aptoide.com/imgs/8/8/7/8877278d2624a2e85335412e4376f22a_icon.png'
        },
        {
          value: 'Poizon',
          label: 'Poizon',
          image: 'https://play-lh.googleusercontent.com/f-69Sd00m_TV1Gu859eSMYFqKBl-Nf3nIMu_wHuvZt9ZV8JB8yyi8yx_qtQAAbegBFEb'
        },
        {
          value: '1688',
          label: '1688',
          image: 'https://cdn-1.webcatalog.io/catalog/1688-com/1688-com-icon-filled-256.png?v=1714773084371'
        }
      ],
      activeConfigList: {}
    }
  },
  // created () {
  //   this.getActiveConfig()
  // },
  methods: {
    setNullValue () {
      this.joinForm.branch = null
    },
    giveOfficerSalbarValue (data) {
      this.whichSalbar = data
    },
    giveWhichSalbarValue (data) {
      this.whichSalbar = data
    },
    async copyAllAddresses () {
      try {
        const allText = `
        Салбарын нэр: ${this.joinForm.branch === 'bohiinurguu' ? '天空0599' : this.joinForm.branch === 'buhiinUrguuExpress' ? '天空快运8818' : ''}
        Утасны дугаар (+86): ${this.joinForm.branch === 'bohiinurguu' ? '13474735577' : this.joinForm.branch === 'buhiinUrguuExpress' ? '13474735577' : ''}
        Муж: ${this.joinForm.branch === 'bohiinurguu' ? '内蒙古自治区' : this.joinForm.branch === 'buhiinUrguuExpress' ? '内蒙古自治区' : ''}
        Лиг: ${this.joinForm.branch === 'bohiinurguu' ? '錫林郭勒盟' : this.joinForm.branch === 'buhiinUrguuExpress' ? '锡林郭勒盟' : ''}
        Эрэнхот хот: ${this.joinForm.branch === 'bohiinurguu' ? '二连浩特市' : this.joinForm.branch === 'buhiinUrguuExpress' ? '二连浩特市' : ''}
        Эрэнхот ХЭЗТХАБ: ${this.joinForm.branch === 'bohiinurguu' ? '二连边境经济技术合作区' : this.joinForm.branch === 'buhiinUrguuExpress' ? '二连边境经济技术合作区' : ''}
        Дэлгэрэнгүй хаяг: ${this.joinForm.branch === 'bohiinurguu' ? '国门金街北区6号商铺爱蒙货代0599tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)' : this.joinForm.branch === 'buhiinUrguuExpress' ? '国门金街北区6号商铺爱蒙货代8818 buhiin urguu express (өөрийн нэр утасны дугаарыг бичнэ)' : ''}
      `
        // Салбарын нэр: ${this.joinForm.branch === 'oficer' ? '天空8792' : this.joinForm.branch === 'bohiinurguu' ? '天空0599' : this.joinForm.branch === 'officerExpress' ? '天空快运8811' : this.joinForm.branch === 'buhiinUrguuExpress' ? '天空快运8818' : this.joinForm.branch === 'gurawHoroolol' ? '天空3819' : ''}
        // Утасны дугаар (+86): ${this.joinForm.branch === 'oficer' ? '13474735577' : this.joinForm.branch === 'bohiinurguu' ? '13474735577' : this.joinForm.branch === 'officerExpress' ? '13474735577' : this.joinForm.branch === 'buhiinUrguuExpress' ? '13474735577' : this.joinForm.branch === 'gurawHoroolol' ? '13474735577' : ''}
        // Муж: ${this.joinForm.branch === 'oficer' ? '内蒙古自治区' : this.joinForm.branch === 'bohiinurguu' ? '内蒙古自治区' : this.joinForm.branch === 'officerExpress' ? '内蒙古自治区' : this.joinForm.branch === 'buhiinUrguuExpress' ? '内蒙古自治区' : this.joinForm.branch === 'gurawHoroolol' ? '内蒙古自治区' : ''}
        // Лиг: ${this.joinForm.branch === 'oficer' ? '錫林郭勒盟' : this.joinForm.branch === 'bohiinurguu' ? '錫林郭勒盟' : this.joinForm.branch === 'officerExpress' ? '锡林郭勒盟' : this.joinForm.branch === 'buhiinUrguuExpress' ? '锡林郭勒盟' : this.joinForm.branch === 'gurawHoroolol' ? '錫林郭勒盟' : ''}
        // Эрэнхот хот: ${this.joinForm.branch === 'oficer' ? '二连浩特市' : this.joinForm.branch === 'bohiinurguu' ? '二连浩特市' : this.joinForm.branch === 'officerExpress' ? '二连浩特市' : this.joinForm.branch === 'buhiinUrguuExpress' ? '二连浩特市' : this.joinForm.branch === 'gurawHoroolol' ? '二连浩特市' : ''}
        // Эрэнхот ХЭЗТХАБ: ${this.joinForm.branch === 'oficer' ? '二连边境经济技术合作区' : this.joinForm.branch === 'bohiinurguu' ? '二连边境经济技术合作区' : this.joinForm.branch === 'officerExpress' ? '二连边境经济技术合作区' : this.joinForm.branch === 'buhiinUrguuExpress' ? '二连边境经济技术合作区' : this.joinForm.branch === 'gurawHoroolol' ? '二连边境经济技术合作区' : ''}
        // Дэлгэрэнгүй хаяг: ${this.joinForm.branch === 'oficer' ? '国门金街北区6号商铺爱蒙货代8792tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)' : this.joinForm.branch === 'bohiinurguu' ? '国门金街北区6号商铺爱蒙货代0599tenger cargo (өөрийн нэр утасны дугаарыг нөхөж бичнэ)' : this.joinForm.branch === 'officerExpress' ? '国门金街北区6号商铺爱蒙货代8811 ofitser express (өөрийн нэр утасны дугаарыг бичнэ)' : this.joinForm.branch === 'buhiinUrguuExpress' ? '国门金街北区6号商铺爱蒙货代8818 buhiin urguu express (өөрийн нэр утасны дугаарыг бичнэ)' : this.joinForm.branch === 'gurawHoroolol' ? '国门金街北区6号商铺爱蒙货代3819tenger 3horoolol (өөрийн нэр утасны дугаарыг нөхөж бичнэ)' : ''}
        await navigator.clipboard.writeText(allText.trim())
        this.isCopiedBranch = this.isCopiedPhone = this.isCopiedMuj = this.isCopiedLig = this.isCopiedEreen = this.isCopiedEreenTo = this.isCopiedDetail = true
        setTimeout(() => {
          this.isCopiedBranch = this.isCopiedPhone = this.isCopiedMuj = this.isCopiedLig = this.isCopiedEreen = this.isCopiedEreenTo = this.isCopiedDetail = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardBranch (text) {
      try {
        await navigator.clipboard.writeText(text)
        this.isCopiedBranch = true
        setTimeout(() => {
          this.isCopiedBranch = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardPhone (text) {
      try {
        await navigator.clipboard.writeText(text) // Текстийг хуулна
        this.isCopiedPhone = true // Copy хийгдсэн төлөвийг өөрчлөх
        setTimeout(() => {
          this.isCopiedPhone = false // 2 секундын дараа буцаах
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardMuj (text) {
      try {
        await navigator.clipboard.writeText(text)
        this.isCopiedMuj = true
        setTimeout(() => {
          this.isCopiedMuj = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardLig (text) {
      try {
        await navigator.clipboard.writeText(text) // Текстийг хуулна
        this.isCopiedLig = true
        setTimeout(() => {
          this.isCopiedLig = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardEreen (text) {
      try {
        await navigator.clipboard.writeText(text) // Текстийг хуулна
        this.isCopiedEreen = true
        setTimeout(() => {
          this.isCopiedEreen = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardEreenTo (text) {
      try {
        await navigator.clipboard.writeText(text) // Текстийг хуулна
        this.isCopiedEreenTo = true
        setTimeout(() => {
          this.isCopiedEreenTo = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardDetail (text) {
      try {
        await navigator.clipboard.writeText(text) // Текстийг хуулна
        this.isCopiedDetail = true
        setTimeout(() => {
          this.isCopiedDetail = false
        }, 2000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    }
  }
}

</script>
<style>
  .join_area {
    border-top: solid #007AFF;
    text-align: center;
    padding-top: 40px !important;
  }
  .success_copy{
    background-color: #007AFF !important;
    color: white !important;
    padding: 30px !important;
    width: 400px !important;
    margin-top: 10px !important;
  }

  .join_info {
    background-color: #D9D9D9;
    width: 400px;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-top: 10px;
  }
  .join_info_area {
    /* text-align: center; */
    justify-items: center;
  }

  .join_branch_option {
    margin-top: 20px;
    justify-content: center;
  }
  .branch_cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
  }
  @media (min-width: 992px) {
    .branch_cards {
      flex-wrap: nowrap;
    }
  }
  .branch_card {
    display: flex;
    justify-content: center;
    flex: 0 0 240px;
  }
  .sub_branch_cards {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;
  }
  @media (min-width: 768px) {
    .sub_branch_cards {
      flex-wrap: nowrap;
    }
  }
  .sub-branch-radio {
    padding: 10px 16px;
  }

  .first_service_item {
    margin-left: 18%;
  }

  .service_title_zone {
    width: 30%;
    color: #5a5a5a;
  }

  .service_title_zone hr {
    background-color: #3c97f8;
  }

  .service_item {
    cursor: pointer;
    margin-top: 20px;
  }

  .service_item i {
    font-size: 30px;
    color: #007AFF;
  }

  .service_item .el-card__body {
    text-align: center;
    align-items: center;
    min-height: 80px;
    padding: 60px;
    border: 2px solid rgb(240 240 240);
  }

  .service_item_desc {
    font-family: 'Geologica', sans-serif;
    font-weight: bold;
  }

  .join_step_image{
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .line-heith-2{
    line-height: 2;
  }
</style>
